/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SearchInputs */

const id_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const ms_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const da_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg`)
};

const de_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche`)
};

const en_us2_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_es2_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_mx2_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fil_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap`)
};

const fr_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const it_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const hu_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés`)
};

const nl_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken`)
};

const no_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk`)
};

const pl_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj`)
};

const pt_br2_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar`)
};

const pt_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ro_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare`)
};

const fi_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae`)
};

const sv_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök`)
};

const vi_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

const tr_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara`)
};

const cs_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const bg_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене`)
};

const ru_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const uk_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук`)
};

const ar_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const hi_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज`)
};

const th_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา`)
};

const ja_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_cn2_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const zh_hant1_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋`)
};

const ko_common_search = /** @type {(inputs: Common_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Common_SearchInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const common_search = /** @type {((inputs?: Common_SearchInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SearchInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_search(inputs)
	if (locale === "ms") return ms_common_search(inputs)
	if (locale === "da") return da_common_search(inputs)
	if (locale === "de") return de_common_search(inputs)
	if (locale === "en-US") return en_us2_common_search(inputs)
	if (locale === "es-ES") return es_es2_common_search(inputs)
	if (locale === "es-MX") return es_mx2_common_search(inputs)
	if (locale === "fil") return fil_common_search(inputs)
	if (locale === "fr") return fr_common_search(inputs)
	if (locale === "it") return it_common_search(inputs)
	if (locale === "hu") return hu_common_search(inputs)
	if (locale === "nl") return nl_common_search(inputs)
	if (locale === "no") return no_common_search(inputs)
	if (locale === "pl") return pl_common_search(inputs)
	if (locale === "pt-BR") return pt_br2_common_search(inputs)
	if (locale === "pt") return pt_common_search(inputs)
	if (locale === "ro") return ro_common_search(inputs)
	if (locale === "fi") return fi_common_search(inputs)
	if (locale === "sv") return sv_common_search(inputs)
	if (locale === "vi") return vi_common_search(inputs)
	if (locale === "tr") return tr_common_search(inputs)
	if (locale === "cs") return cs_common_search(inputs)
	if (locale === "bg") return bg_common_search(inputs)
	if (locale === "ru") return ru_common_search(inputs)
	if (locale === "uk") return uk_common_search(inputs)
	if (locale === "ar") return ar_common_search(inputs)
	if (locale === "hi") return hi_common_search(inputs)
	if (locale === "th") return th_common_search(inputs)
	if (locale === "ja") return ja_common_search(inputs)
	if (locale === "zh-CN") return zh_cn2_common_search(inputs)
	if (locale === "zh-Hant") return zh_hant1_common_search(inputs)
	return ko_common_search(inputs)
});
export { common_search as "common.search" }